(() => {
  function qsa(root, sel) {
    return Array.from(root.querySelectorAll(sel));
  }

  function showPanel(tree, level) {
    qsa(tree, ".category-tree__panel").forEach((p) => {
      p.hidden = p.getAttribute("data-level") !== String(level);
    });

    const panelInput = tree.querySelector('input[name="ct_panel"][data-ct-panel]');
    if (panelInput) panelInput.value = String(level);
  }

  function findInput(tree, level, value) {
    const inputs = qsa(tree, `input[data-ct-level="${level}"]`);
    return inputs.find((i) => i.value === value) || null;
  }

  function clearLevelsFrom(tree, fromLevel) {
    qsa(tree, "input[data-ct-level]").forEach((i) => {
      const lvl = parseInt(i.getAttribute("data-ct-level"), 10);
      if (lvl >= fromLevel) i.checked = false;
    });
  }

  function triggerDawnUpdate(tree) {
    const form = tree.closest("form");
    if (!form) return;
    form.dispatchEvent(new Event("input", { bubbles: true }));
    form.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function setActiveButtons(tree) {
    qsa(tree, "[data-ct-pick]").forEach((btn) => btn.classList.remove("active"));

    qsa(tree, "input[data-ct-level]:checked").forEach((inp) => {
      const lvl = inp.getAttribute("data-ct-level");
      const val = inp.value;

      const btn = tree.querySelector(
        `[data-ct-pick][data-level="${lvl}"][data-value="${CSS.escape(val)}"]`
      );
      if (btn) btn.classList.add("active");
    });
  }

  function getPanelFromHidden(tree) {
    const panelInput = tree.querySelector('input[name="ct_panel"][data-ct-panel]');
    const v = panelInput ? parseInt(panelInput.value || "0", 10) : 0;
    return v >= 1 && v <= 4 ? v : 1;
  }

  function init(tree) {
    if (tree.__ct_inited) return;
    tree.__ct_inited = true;

    showPanel(tree, getPanelFromHidden(tree));
    setActiveButtons(tree);

    qsa(tree, "[data-ct-pick]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const level = parseInt(btn.getAttribute("data-level"), 10);
        const value = btn.getAttribute("data-value") || "";

        const input = findInput(tree, level, value);
        if (!input || input.disabled) return;

        qsa(tree, `input[data-ct-level="${level}"]`).forEach((i) => (i.checked = false));
        clearLevelsFrom(tree, level + 1);
        input.checked = true;

        if (level === 4) showPanel(tree, 4);
        else showPanel(tree, Math.min(level + 1, 4));

        setActiveButtons(tree);
        triggerDawnUpdate(tree);
      });
    });

    qsa(tree, "[data-ct-back]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const to = parseInt(btn.getAttribute("data-to"), 10);
        const clearFrom = parseInt(btn.getAttribute("data-clear-from"), 10);

        clearLevelsFrom(tree, clearFrom);
        showPanel(tree, to);

        setActiveButtons(tree);
        triggerDawnUpdate(tree);
      });
    });
  }

  function scan() {
    document.querySelectorAll("[data-category-tree]").forEach((tree) => init(tree));
  }

  document.addEventListener("DOMContentLoaded", () => {
    scan();
    const mo = new MutationObserver(() => {
      document.querySelectorAll("[data-category-tree]").forEach((tree) => (tree.__ct_inited = false));
      scan();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
